var m = document.cookie.match(/(?:^|; )theme=([^;]*)/)
var s = (m && m[1]) || localStorage.getItem('theme')
var d = s === 'dark' || (s !== 'light' && window.matchMedia('(prefers-color-scheme: dark)').matches)
var e = document.documentElement

e.classList.toggle('dark', d)
e.style.colorScheme = d ? 'dark' : 'light'
e.style.backgroundColor = d ? 'oklch(19.7% 0.0126 55.5deg)' : 'oklch(95.7% 0.0119 79.8deg)'

document.addEventListener('DOMContentLoaded', function () {
  e.style.removeProperty('color-scheme')
  e.style.removeProperty('background-color')
})
